<!--
 * @FileDescription: 个人分销账户详情
 * @Author: xy（作者）
 * @Date: 2020-12-31（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
        <div class="page-container-height">
            <div class="order-top">
                <span style="margin-right:60px">用户手机号：{{queryobj.mobile}}</span>
                <span style="margin-right:60px">总收入：¥{{queryobj.cumulativeIncome}}</span>
                <span style="margin-right:60px">总支出：¥{{queryobj.cumulativeExpenditure}}</span>  
                <span>零钱：¥{{queryobj.balance}}</span>   
            </div>
            <div class="line"></div> 
            <div class="market-tab">
                <div class="market-tab-item" :class="tabindex == 0 ? 'market-tab-item-active':''" @click="changTab(0)">
                    <img src="@/assets/image/adjustment-img4.png" alt="" v-if="tabindex == 0">
                    <img src="@/assets/image/adjustment-img1.png" alt="" v-else>
                    全部
                </div>
                 <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 1 ? 'market-tab-item-active':''" @click="changTab(1)">
                    <img src="@/assets/image/shouru2.png" alt="" v-if="tabindex == 1">
                    <img src="@/assets/image/shouru1.png" alt="" v-else>
                    收入
                </div>
                <div class="market-tab-line"></div>
                <div class="market-tab-item" :class="tabindex == 2 ? 'market-tab-item-active':''" @click="changTab(2)">
                    <img src="@/assets/image/zhichu3.png" alt="" v-if="tabindex == 2">
                    <img src="@/assets/image/zhichu4.png" alt="" v-else>
                    支出
                </div>
            </div> 
            <a-table :columns="columns"
                    :dataSource="dataSource"
                    :pagination="false"
                    :scroll="{y: 'calc(100vh - 310px)' }"
                    class="table-log-height"
                    bordered
                    rowKey="key">
            </a-table>
             <div class="pagination-footer-box">
                <a-pagination :total="pagination.total" :page-size="pagination.pageSize" :default-current="pagination.current"
                    :show-total="pagination.showTotal" @showSizeChange="onShowSizeChange" @change="handleTableChange"
                    show-size-changer show-quick-jumper />
            </div>
      </div>
  </div>
</template>
<script>
import {getPageAccount} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import {method} from './method/method'  
export default {
    mixins:[mixins,method],
    name:'personalDetail',
    data(){
        return{
            tabindex:0,
            footerDataSource:[],
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 70,
                    align: 'center',
                    fixed: 'left',
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '收支类型',
                    key: 'incomeExpenditureType',
                    dataIndex: 'incomeExpenditureType',
                     customRender(t, r, index) {
                         if(t == 1){
                             return '收入'
                         }else{
                             return '支出'
                         }
                    }
                },
                {
                    title: '发生类型',
                    key: 'itemTypeName',
                    dataIndex: 'itemTypeName',
                },
                {
                    title: '金额',
                    dataIndex: 'amount',
                    key: 'amount',
                     align: 'right',
                },
                {
                    title: '发生时间',
                    dataIndex: 'generationTime',
                    key: 'generationTime',
                },
            ],
            dataSource: [],
            queryobj:{},
        }
    },
    watch: {

    },
    mounted () {

    },
    created () {

    },
    components: {

    },
    activated(){
        this.detailId= this.$route.query.id
        this.queryobj= this.$route.query
        this.getmessagedata()
    },
    beforeRouteUpdate(to,from,next){
        this.detailId= to.query.id
        this.queryobj= to.query
        this.getmessagedata()
        next()
    },
    methods: {
        getmessagedata(){
            this.getmessageobj('/mall-account/web/account/pageListAccountItem',{   
                    companyStoreId:this.$store.state.shopId,
                    current:this.pagination.current,
                    size:this.pagination.pageSize,
                    accountId:this.detailId,
                    incomeExpenditureType:this.tabindex,
                },{})
        },
        changTab(index){
            this.tabindex = index
            this.pagination.current = 1
            this.getmessagedata()
        }
    },

}
</script>
<style scoped lang="scss">
    .page-container-height{
        background: #ffffff;
        .order-top{
            height: 80px;
            padding: 0 30px;
            display: flex;
            align-items: center;

        }
        .market-tab{
            padding: 10px 30px;
            display: flex;
            align-items: center;
            .market-tab-item{
                color: #919191;
                font-size: 16px;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 10px;
                }
            }
            .market-tab-item-active{
                color: #387bfc;
            }
            .market-tab-line{
                width: 1px;
                height: 18px;
                background: #919191;
                margin: 0 30px;
            } 
        }
    }
</style>

